import React from 'react'
import OneColWrapper from '../technical/OneColWrapper'
import Headline from '../atoms/Headline'
import Richtext from '../atoms/Richtext'

const TextBlock = ({ block, className }) => {
  return (
    <OneColWrapper block={block} className={className}>
      <Headline
        kicker={block.kicker}
        headline={block.headline}
        headline_level={block.headline_level}
        subheadline={block.subheadline}
      />
      <Richtext text={block.text} />
    </OneColWrapper>
  )
}

export default TextBlock
